import { Button } from "components/Button";
import { motion } from "framer-motion";
import InfiniteScroll from "react-infinite-scroll-component";
import { useCampaignsStore } from "screens/Campaigns/store";
import { SquareLoader } from "screens/Main/components/Loader/SquareLoader";
import { ProjectsAddForm } from "../../ProjectsAddForm";
import { campaignsApi } from "screens/Campaigns/service";
import { useEffect, useState } from "react";
import { ProjectCard } from "../../Cards/ProjectCard";

export const ProjectsPanel = () => {
  const {
    isOpenAddProjectForm,
    setIsOpenAddProjectForm,
    projects,
    setProjects,
    hasMoreProjects,
    totalProjectsPages,
    projectsPage,
    isLoadMoreLoading,
    setIsLoadMoreLoading,
    setProjectsPage,
    setCampaigns
  } = useCampaignsStore();
  const [isLoading, setIsLoading] = useState(false);

  const loadMore = async () => {
    if (!hasMoreProjects) return;
    if (totalProjectsPages < projectsPage + 1) return;

    setIsLoadMoreLoading(true);

    const nextPage = projectsPage + 1;

    try {
      const nextProjects = await campaignsApi.getAllProjects(nextPage);

      const isThereMore = nextPage < totalProjectsPages;
      setProjectsPage(isThereMore ? nextPage : projectsPage);
      if (nextProjects) {
        setProjects([...projects, ...nextProjects]);
      }
    } catch (error) {
      console.error("Error loading campaigns data", error);
    } finally {
      setIsLoadMoreLoading(false);
    }
  };

  const getAllProjectsHandler = async () => {
    setIsLoading(true);
    try {
      const pageToLoad = 1;
      const projects = await campaignsApi.getAllProjects(pageToLoad);
      const campaigns = await campaignsApi.getAllCampaigns(1);

      if (campaigns) {
        setCampaigns(campaigns);
      }

      if (projects) {
        setProjects(projects);
        setProjectsPage(pageToLoad);
      }
    } catch (error) {
      console.error("Error loading projects data", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteProject = async (id: string) => {
    setIsLoading(true);
    await campaignsApi.deleteProject(id);
    await getAllProjectsHandler();
    setIsLoading(false);
  };

  useEffect(() => {
    getAllProjectsHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Button
        extraClass="flex items-center justify-center justify-self-center mb-[60px] min-w-[192px]"
        onClick={() => setIsOpenAddProjectForm(true)}
      >
        <span className="mr-[10px] text-[18px]">+</span> Add new project
      </Button>
      <div className="w-full">
        <p className="font-[700] mb-[24px]">All projects ({projects.length})</p>
        {isLoading ? (
          <div className="flex w-full  my-[20px] justify-center  items-center">
            <SquareLoader size={32} />
          </div>
        ) : (
          <InfiniteScroll
            dataLength={projects ? projects.length : 0}
            next={() => loadMore()}
            hasMore={hasMoreProjects}
            loader={null}
            endMessage={null}
          >
            <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-7 w-full mb-16">
              {projects && projects.length > 0 ? (
                projects.map((project, i) => (
                  <motion.article
                    initial={{
                      y: 50,
                      opacity: 0
                    }}
                    whileInView={{
                      y: 0,
                      opacity: 1
                    }}
                    transition={{
                      duration: 0.1,
                      delay: 0.1 * (i % 3)
                    }}
                    viewport={{
                      once: true,
                      margin: "-20% 0%"
                    }}
                    key={i}
                    className="relative flex flex-col gap-[8px] min-h-[251px] py-[22px] pl-[19px] pr-[24px] bg-[#171717]"
                  >
                    <ProjectCard
                      project={project}
                      deleteProject={handleDeleteProject}
                    />
                  </motion.article>
                ))
              ) : (
                <p className="W-full flex items-center justify-center mt-[50px]">
                  No projects available
                </p>
              )}
            </section>
          </InfiniteScroll>
        )}
        {hasMoreProjects && !isLoading && (
          <div className="flex w-full justify-center">
            <Button
              extraClass="flex items-center justify-center mb-[60px] min-w-[192px]"
              onClick={loadMore}
            >
              {isLoadMoreLoading ? (
                <div className="flex w-full justify-center  items-center">
                  <SquareLoader size={32} />
                </div>
              ) : (
                <span>Load more...</span>
              )}
            </Button>
          </div>
        )}
      </div>
      <ProjectsAddForm
        isOpen={isOpenAddProjectForm}
        onClose={() => setIsOpenAddProjectForm(false)}
        getAllProjectsHandler={getAllProjectsHandler}
      />
    </>
  );
};
